export enum ResStatus {
  OK = 'OK',
  NOT_FOUND = 'NOT_FOUND',
  BAD_REQUEST = 'BAD_REQUEST',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  UNKNOWN_RESPONSE_STATUS = 'UNKNOWN_RESPONSE_STATUS',
}

export interface Res<R> {
  status: ResStatus;
  message: null | string;
  details: null | string;
  result: R;
}

export interface MailStub {
  bcc: string[];
  cc: string[];
  to: string[];
  from: string;
  replyTo: string;
  sentDate: null;
  subject: string;
  text: string;
}

export interface BaseParams {
  filterText?: string;
  pageNumber?: number;
}
